class ConfiguratorSkargard {
    constructor() {
        this.id = 'furniture';
        this.cache = {};
        this.sizes = [];

        this.selectors = [
            'fabric',
            'size'
        ];

        for (const sel of this.selectors) {
            configurator.addSelectorItem(sel);
        }

        this.init();
    }

    async init() {
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }
    
    setupListeners() {
    }

    async refresh(selector) {
        if (Object.keys(this.cache).length == 0) {
            await this.loadBuyables();
        }
        
        if (this.selectors.includes('fabric')) { this.populateFabrics(); }
        if (this.selectors.includes('size')) { this.populateSizes(); }
    }

    populateFabrics() {
        const items = [];
        let g = "";

        for (const key in configurator.m3_fabrics) {
            if (!(key in this.cache)) { continue; } // Fabric not available for this product
            if (configurator.m3_fabrics[key][3] != 1) { continue; }

            const thumbnail = configurator.getSwatch(configurator.m3_fabrics[key][0]);
            const item = {
                'id': key,
                'label': configurator.m3_fabrics[key][1],
                'thumbnail': thumbnail,
                'group_by': configurator.m3_fabrics[key][2]
            };
            
            items.push(item);
        }
        
        configurator.renderSelector('fabric', items, {
            'thumbnails': true,
            'allow_none': false,
        });
    }

    populateSizes() {
        const sizes = this.cache[ configurator.selection.fabric ]['sizes'];
        const items = [];

        // Sort sizes
        var sizesSorted = [].slice.call(Object.keys(sizes)).sort((a, b) => {
            const a1 = a.split('x');
            const b1 = b.split('x');
            return a1[0] - b1[0] || a1[1] - b1[1];
        });

        for (const size of sizesSorted) {
            items.push({
                'id': size,
                'label': sizes[size].html,
                'thumbnail': null,
                'group_by': sizes[size].group_by
            });
        }

        configurator.renderSelector('size', items, {
            'columns': 5,
            'allow_none': false,
        });
        if (configurator.selection.size != null) { configurator.updateSelectorState( 'size' ); }
    }

    async loadBuyables() {
        const products = await configurator.loadProductData('configurator-headboards', [
            {key: 'category', value: bed_configuration.category},
        ], ['size', 'fabric', 'width', 'height', 'length'], true);
        const urlParams = new URLSearchParams(window.location.search);
        const variant_id = 'gid://shopify/ProductVariant/' + urlParams.get('variant');

        for (const product of products) {
            const size = product.size ? product.size : 'nosize';

            if (!(product.fabric in this.cache)) {
                this.cache[ product.fabric ] = { 'title': product.fabric, 'sizes': {} };
            }
            
            const variant = product.variants[0];
            if (!variant) { continue; }

            const size_arr = size.split('x');
            for (let dim = 1; dim <= 4; dim++) {

                const size_x = parseInt(size_arr[0]) * dim;
                const size_y = parseInt(size_arr[1]);
                const dim_y = size_y / 45;

                const ids = [];
                const skus = [];
                let price = 0;
                for (let i = 0; i < dim; i++) {
                    ids.push( variant.id.replace('gid://shopify/ProductVariant/', '') );
                    skus.push( variant.sku );
                    price += variant.price;
                }

                this.cache[ product.fabric ].sizes[ size_x+'x'+size_y ] = {
                    'id': product.productid,
                    'handle': product.productid,
                    'label': `${size_x}x${size_y} (${dim}x${dim_y} modules)`,
                    'code': `${size_y}x${size_x} (${dim_y}x${dim} moduls)`,
                    'html': `${size_x}x${size_y}`,
                    'group_by': `${dim} module`,
                    'ids': ids,
                    'skus': skus,
                    'price': price,
                    'thumbnail': variant.featured_image ? variant.featured_image.src : (product.images.length > 0 ? product.images[0].src: null),
                    'dimensions': [
                        this.safelyDivideToCm(product.width) * dim, // width scales with the module count
                        this.safelyDivideToCm(product.length),      // depth - per module, does not scale
                        this.safelyDivideToCm(product.height)       // height - per module, does not scale
                    ],
                };
            }

            if (variant.id.replace('gid://shopify/ProductVariant/', '') == variant_id) {
                configurator.selection['size'] = variant.size;
                configurator.selection['fabric'] = variant.fabric;
            }
        }

        if (!configurator.selection['fabric']) {
            configurator.selection['fabric'] = '0LLG'; // Default?
        }
        if (!(configurator.selection['fabric'] in this.cache)) {
            configurator.selection['fabric'] = Object.keys(this.cache)[0];
        }

        if (!configurator.selection['size']) {
            configurator.selection['size'] = Object.keys(this.cache[ configurator.selection['fabric'] ]['sizes'])[0]; // Default?
        }
    }

    isSoldOut() {
        return false;
    }

    getPriceData(priceData) {
        const items = [];

        // Load base with specific fabric
        let item = this.cache[ configurator.selection.fabric ].sizes[ configurator.selection.size ];

        if (item != null) {
            const price = item.price ?? 0; //!= undefined ? item.price : 0;
            console.log("furniture"+" => "+item.id+" => "+price);
            priceData.total += price;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);

            const dimensionsElement = document.querySelector('.dimensions');
            if (dimensionsElement && item.dimensions && item.dimensions.some(d => d > 0)) {
                dimensionsElement.querySelector('.dimensions-value').textContent = "B x L x H: " + item.dimensions.join(' x ') + " cm";
                dimensionsElement.hidden = false;
            } else if (dimensionsElement) {
                dimensionsElement.hidden = true;
            }
        }
    }

    getCylindoSpecs(specs) {
        if (configurator.selection.fabric != null) {
            specs.features.UPHOLSTERY = configurator.m3_fabrics[ configurator.selection.fabric ][0];
        }

        const model = bed_configuration.cylindo_model.toLowerCase();
        const model_size = this.cache[ configurator.selection.fabric ].sizes[ configurator.selection.size ];
        specs.features.size = model_size.code.toUpperCase();
    }

    safelyDivideToCm(value) {
        if (!value || isNaN(parseFloat(value))) return 0;
        return parseFloat(value) / 10;
    }
}